import React from 'react';
import { useNavigate } from 'react-router-dom';

function Home() {
    const navigate = useNavigate();

    const handleLogin = () => {
        navigate('/signin'); 
    };

    return(
        <>
        <h1>Welcome to world, the home page!</h1>
        <div onClick={handleLogin}>Sign in</div>
        </>
    );
}

export default Home;